// TradingViewWidget.js

import React, { useEffect, useRef } from 'react';

let tvScriptLoadingPromise;

export default function SoybeanTrading() {
    const onLoadScriptRef = useRef();

    useEffect(
        () => {
            onLoadScriptRef.current = createWidget;

            if (!tvScriptLoadingPromise) {
                tvScriptLoadingPromise = new Promise((resolve) => {
                    const script = document.createElement('script');
                    script.id = 'tradingview-widget-loading-script';
                    script.src = 'https://s3.tradingview.com/tv.js';
                    script.type = 'text/javascript';
                    script.onload = resolve;

                    document.head.appendChild(script);
                });
            }

            tvScriptLoadingPromise.then(() => onLoadScriptRef.current && onLoadScriptRef.current());

            return () => onLoadScriptRef.current = null;

            function createWidget() {
                if (document.getElementById('tradingview_76300') && 'TradingView' in window) {
                    new window.TradingView.widget({
                        autosize: true,
                        symbol: "CBOT:ZS1!",
                        interval: "D",
                        timezone: "Etc/UTC",
                        theme: "dark",
                        style: "1",
                        locale: "en",
                        toolbar_bg: "#f1f3f6",
                        enable_publishing: false,
                        allow_symbol_change: true,
                        container_id: "tradingview_76300"
                    });
                }
            }
        },
        []
    );

    return (
        <div className='tradingview-widget-container'>
            <div id='tradingview_76300' style={{ height: '300px', marginBottom: '20px' }} />
            <div className='zoomup-button-grid'>
                <button className='zoomup-button'>
                    ขยาย
                </button>
            </div>
            {/* <div className="tradingview-widget-copyright">
                <a href="https://www.tradingview.com/symbols/CBOT-ZS1!/" rel="noopener" target="_blank"><span className="blue-text">ZS1! chart</span></a> by TradingView
            </div> */}
        </div>
    );
}
